import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=24987ec1&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24987ec1')) {
      api.createRecord('24987ec1', component.options)
    } else {
      api.reload('24987ec1', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=24987ec1&", function () {
      api.rerender('24987ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/AddInfo/Company.vue"
export default component.exports